import angular from 'angular'
import './event.service'

angular.module('admin.event', ['admin.event.service']).controller('EventCtrl', EventCtrl)

/** @ngInject */
function EventCtrl(
  $scope,
  $state,
  $timeout,
  EventService,
  PublisherAdminService,
  NotificationHistoryService,
  BundleService,
  PostsService,
) {
  var vm = this
  vm.events = []
  vm.eventSource = []
  vm.listChannelPosts = []
  vm.edit = false
  vm.notPermission = false
  vm.ownPublisherId = 0
  vm.isByFilterChannel = false

  function init() {
    vm.start = null
    vm.end = null
    vm.waitChannel = true
    vm.waitSet = true
    vm.channelId = null
    vm.setId = null
    vm.packId = null
    vm.t = null
    vm.txt = null
    vm.ts = null
    vm.isClone = false
    vm.isOpen = false
    vm.currentEvent = null
    vm.channelPostId = null
  }

  init()

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()
    vm.isOpen = true
  }

  vm.back = function () {
    if (
      $('.fc-basicDay-button').hasClass('fc-state-active') ||
      $('.fc-agendaWeek-button').hasClass('fc-state-active')
    ) {
      vm.reload()
    } else {
      $state.go('admin.home')
    }
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  function load(firstDay, endDay) {
    EventService.list(firstDay, endDay).then(function (result) {
      var events = result.results
      vm.events = []
      vm.eventSource = events
      for (var i = 0; i < events.length; i++) {
        var event = events[i]
        var ts = new Date(
          parseInt(event['ts-p'].toString().substring(0, event['ts-p'].toString().length - 3)),
        )
        vm.events.push({
          id: event.id,
          title: event.t,
          start: ts,
          end: ts,
        })
      }

      var local = JSON.parse(localStorage.user)
      if (local !== null) {
        if (local.user.producer) {
          PublisherAdminService.get(local.user.producer['id-pu']).then(function (result) {
            vm.channels = result.results.ch
            for (var i = 0; i < vm.channels.length; i++) {
              vm.channels[i].isActive = false
            }
            vm.ownPublisherId = result.results.id
          })
        } else {
          swal("You're not on any publisher.", "You can't use this feature.", 'warning')
          vm.notPermission = true
        }
      } else {
        $state.go('login')
      }

      $('#calendar').fullCalendar('removeEvents')
      $('#calendar').fullCalendar('renderEvents', vm.events, true)
    })

    EventService.listChannels().then(function (result) {
      vm.allChannels = result.results
      for (var i = 0; i < vm.allChannels.length; i++) {
        vm.allChannels[i].isActive = false
      }
    })
  }

  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth()
  var firstDay = parseInt(new Date(y, m, 1).getTime() + '000')
  var lastDay = parseInt(new Date(y, m + 1, 0).getTime() + '000')
  load(firstDay, lastDay)
  loadCalendar()

  vm.reload = function () {
    $('#calendar').fullCalendar('destroy')
    load()
  }

  vm.cancel = function () {
    $('#calendar').fullCalendar('unselect')
    $('#myModal').modal('hide')
  }

  vm.save = function () {
    if (vm.channelId === null || vm.setId === null || vm.t === null || vm.txt === null) {
      swal('Need complete all fields.', '', 'warning')
      return
    }

    if (vm.t.length > 100) {
      swal('Limit title 100 characters', '', 'warning')
      return
    }

    if (vm.txt.length > 256) {
      swal('Limit description 256 characters', '', 'warning')
      return
    }

    if (vm.date !== null) {
      if (isDate(vm.date)) {
        var date = parseInt(new Date(new Date(vm.date).setSeconds(0)).getTime() * 1000)
        vm.ts = date
      }
    } else {
      swal('Date & Time invalid field.', '', 'warning')
      return
    }

    var model = {
      t: vm.t,
      txt: vm.txt,
      'ts-p': vm.ts,
    }

    var eventData = {
      title: vm.t,
      start: vm.date,
      end: vm.date,
    }

    if (vm.packId !== null) {
      EventService.getBundle(vm.packId).then(function (resultBundle) {
        BundleService.clone(vm.packId, resultBundle.results).then(function (result) {
          var bundleCloned = result.results
          model['id-b'] = bundleCloned.id
          if (vm.channelPostId === null) {
            EventService.save(vm.setId, model).then(function (result2) {
              var eventResult = result2.results
              vm.eventSource.push(eventResult)
              eventData.id = eventResult.id
              var ts = ''
              var channelId = eventResult.b.s['id-ch']
              var channel = _.find(vm.allChannels, { id: eventResult.b.s['id-ch'] })
              var channelName = channel.t + ','
              var bundleId = eventResult.b.id
              var jsonBody = {
                target: 'channels',
                k: 'b',
                group: 'all',
                s: bundleId,
                users: [channelId],
                channels: channelName,
              }
              NotificationHistoryService.update(eventResult.pn.id, {
                dl: 'bundles/' + bundleId,
                to: JSON.stringify(jsonBody),
              }).then(function () {
                if (eventResult.pn['ts-p'] !== undefined) {
                  ts = new Date(
                    parseInt(
                      eventResult.pn['ts-p']
                        .toString()
                        .substring(0, eventResult.pn['ts-p'].toString().length - 3),
                    ),
                  )
                  if (ts <= new Date()) {
                    NotificationHistoryService.publish(eventResult.pn.id).then(function () {
                      renderAndClose(eventData, 'create', eventResult)
                    })
                    return
                  }
                }
                renderAndClose(eventData, 'create', eventResult)
              })
            })
          } else {
            var resultChannelPost = _.find(vm.listChannelPosts, { id: vm.channelPostId })
            var clone = {
              t: resultChannelPost.t,
              txt: resultChannelPost.txt,
              url: 'bundles/' + model['id-b'],
              urlt: resultChannelPost.urlt,
              'img-h': resultChannelPost['img-h'],
              'id-ch': vm.channelId,
              k: resultChannelPost.k,
              n: resultChannelPost.n,
            }
            EventService.save(vm.setId, model).then(function (result2) {
              var eventResult = result2.results
              PostsService.update(vm.channelId, eventResult['id-po'], clone).then(function () {
                vm.eventSource.push(eventResult)
                eventData.id = eventResult.id
                var ts = ''
                var channelId = eventResult.b.s['id-ch']
                var channel = _.find(vm.allChannels, { id: eventResult.b.s['id-ch'] })
                var channelName = channel.t + ','
                var bundleId = eventResult.b.id
                var jsonBody = {
                  target: 'channels',
                  k: 'b',
                  group: 'all',
                  s: bundleId,
                  users: [channelId],
                  channels: channelName,
                }
                NotificationHistoryService.update(eventResult.pn.id, {
                  dl: 'bundles/' + bundleId,
                  to: JSON.stringify(jsonBody),
                }).then(function () {
                  if (eventResult.pn['ts-p'] !== undefined) {
                    ts = new Date(
                      parseInt(
                        eventResult.pn['ts-p']
                          .toString()
                          .substring(0, eventResult.pn['ts-p'].toString().length - 3),
                      ),
                    )
                    if (ts <= new Date()) {
                      NotificationHistoryService.publish(eventResult.pn.id).then(function () {
                        renderAndClose(eventData, 'create', eventResult)
                      })
                      return
                    }
                  }
                  renderAndClose(eventData, 'create', eventResult)
                })
              })
            })
          }
        })
      })
    } else {
      EventService.save(vm.setId, model).then(function (result2) {
        var eventResult = result2.results
        vm.eventSource.push(eventResult)
        eventData.id = eventResult.id
        var ts = ''
        var channelId = eventResult.b.s['id-ch']
        var channel = _.find(vm.allChannels, { id: eventResult.b.s['id-ch'] })
        var channelName = channel.t + ','
        var bundleId = eventResult.b.id
        var jsonBody = {
          target: 'channels',
          k: 'b',
          group: 'all',
          s: bundleId,
          users: [channelId],
          channels: channelName,
        }
        NotificationHistoryService.update(eventResult.pn.id, {
          dl: 'bundles/' + bundleId,
          to: JSON.stringify(jsonBody),
        }).then(function () {
          if (eventResult.pn['ts-p'] !== undefined) {
            ts = new Date(
              parseInt(
                eventResult.pn['ts-p']
                  .toString()
                  .substring(0, eventResult.pn['ts-p'].toString().length - 3),
              ),
            )
            if (ts <= new Date()) {
              NotificationHistoryService.publish(eventResult.pn.id).then(function () {
                renderAndClose(eventData, 'create', eventResult)
              })
              return
            }
          }
          renderAndClose(eventData, 'create', eventResult)
        })
      })
    }
  }

  vm.update = function () {
    if (vm.date !== null) {
      if (isDate(vm.date)) {
        var date = parseInt(new Date(new Date(vm.date).setSeconds(0)).getTime() * 1000)
        vm.ts = date
      }
    } else {
      swal('Date & Time invalid field.', '', 'warning')
      return
    }

    var eventData = {
      title: vm.t,
      start: vm.date,
      end: vm.date,
    }

    var isBeenPublished = vm.date < new Date()
    swal(
      {
        title: 'Are you Sure?',
        text: isBeenPublished
          ? 'This event package is been published are you sure change the date?'
          : '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          EventService.update(vm.currentEvent.id, { 'ts-p': vm.ts, t: vm.t, txt: vm.txt }).then(
            function (result) {
              var eventResult = result.results
              for (var i = 0; i < vm.eventSource.length; i++) {
                if (vm.eventSource[i].id === eventResult.id) {
                  vm.eventSource.remove(vm.eventSource[i])
                  vm.eventSource.push(eventResult)
                  break
                }
              }
              eventData.id = eventResult.id
              removeEventCalendar()
              $timeout(function () {
                renderAndClose(eventData)
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.delete = function () {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          EventService.remove(vm.currentEvent.id).then(
            function (result) {
              var eventResult = result.results
              for (var i = 0; i < vm.eventSource.length; i++) {
                if (vm.eventSource[i].id === eventResult.id) {
                  vm.eventSource.remove(vm.eventSource[i])
                  break
                }
              }
              removeEventCalendar()
              $('#calendar').fullCalendar('unselect')
              $('#myModal').modal('hide')
            },
            function (result) {
              $timeout(function () {
                swal(result.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  function removeEventCalendar() {
    $('#calendar').fullCalendar('removeEvents', vm.currentEvent.id)
  }

  function renderAndClose(eventData, method, result) {
    $('#calendar').fullCalendar('renderEvent', eventData, true)
    $('#calendar').fullCalendar('unselect')
    $('#myModal').modal('hide')
    init()

    $timeout(function () {
      if (method === 'create') {
        $('.modal-open').css('overflow', 'initial')
        localStorage.setItem('bundleId', result.b.id)
        localStorage.setItem('channelId', result.b.s['id-ch'])
        localStorage.setItem('pushId', result.pn.id)
        localStorage.setItem('setId', result.b.s.id)
        var channel = _.find(vm.allChannels, { id: result.b.s['id-ch'] })
        localStorage.setItem('channelName', channel.t)
        $state.go('pub.bundles.step1', {
          parentId: result.b.s.id,
          id: result.b.id,
          event: true,
          create: true,
          post: result.p.id,
        })
      }
    }, 500)
  }

  function loadCalendar() {
    var defaultDate
    if (vm.isByFilterChannel) {
      defaultDate = vm.dateOldCalendar
    } else {
      defaultDate = new Date()
    }

    $('#calendar').fullCalendar({
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,basicDay',
      },
      views: {
        listDay: { buttonText: 'list day' },
        listWeek: { buttonText: 'list week' },
      },
      defaultDate: defaultDate,
      navLinks: true,
      editable: true,
      selectable: true,
      selectHelper: true,
      eventLimit: true,
      events: vm.events,
      timezone: 'local',
      timeFormat: 'LT',
      select: function (start, end) {
        init()
        var startDate = moment(start).format('l')
        var endDate = moment(end).subtract(1, 'day').format('l')
        var startWeek = moment(start).format('l')
        var endWeek = moment(end).format('l')

        if (startWeek !== endWeek) {
          if (startDate !== endDate) {
            $('#calendar').fullCalendar('unselect')
            return
          }
        }

        vm.start = start
        vm.end = end
        if ($('.fc-state-active').text() === 'month' || $('.fc-state-active').text() === 'day') {
          vm.date = new Date(end.format())
        } else {
          vm.date = new Date(start.format())
        }
        vm.channelId = null
        vm.setId = null
        vm.t = null
        vm.txt = null
        vm.edit = false

        $('#myModal').modal('show')

        $scope.$apply()
      },
      eventClick: function (calEvent) {
        EventService.get(calEvent.id).then(function (result) {
          var event = result.results
          var eventCache = _.find(vm.eventSource, { id: calEvent.id })
          event.b.s = eventCache.b.s
          vm.currentEvent = event

          var permissionChannel = _.find(vm.allChannels, { id: event.b.s['id-ch'] })
          if (permissionChannel['id-pu'] !== vm.ownPublisherId) {
            swal('You are not allowed to change this event', '', 'warning')
            return
          }

          if (event !== null) {
            var ts = new Date(
              parseInt(event['ts-p'].toString().substring(0, event['ts-p'].toString().length - 3)),
            )
            vm.channelId = event.b.s['id-ch']
            vm.waitChannel = false
            vm.setId = event.b.s.id
            vm.t = event.t
            vm.txt = event.txt
            vm.date = ts
            if (event.k === 0) {
              vm.waitSet = true
              vm.isClone = false
            } else {
              vm.isClone = true
              vm.waitSet = false
              vm.packId = event.b.id
            }

            if (event.b !== undefined) {
              var ts1 = ''
              if (event.b['ts-p'] !== undefined) {
                ts1 = new Date(
                  parseInt(
                    event.b['ts-p'].toString().substring(0, event.b['ts-p'].toString().length - 3),
                  ),
                )
              }
              vm.bundleModel = {
                id: event.b.id,
                t: event.b.t,
                st: event.b.st,
                pat: ts1,
                model: event,
              }
            } else {
              vm.bundleModel = undefined
            }

            if (event.p !== undefined) {
              var ts2 = ''
              if (event.p['ts-p'] !== undefined) {
                ts2 = new Date(
                  parseInt(
                    event.p['ts-p'].toString().substring(0, event.p['ts-p'].toString().length - 3),
                  ),
                )
              }
              vm.postModel = {
                id: event.p.id,
                t: event.p.t,
                pat: ts2,
                model: event,
              }
            } else {
              vm.postModel = undefined
            }

            if (event.pn !== undefined) {
              var ts3 = ''
              if (event.pn['ts-p'] !== undefined) {
                ts3 = new Date(
                  parseInt(
                    event.pn['ts-p']
                      .toString()
                      .substring(0, event.pn['ts-p'].toString().length - 3),
                  ),
                )
              }
              vm.notificationModel = {
                id: event.pn.id,
                t: event.pn.txt,
                pat: ts3,
                model: event,
              }
            } else {
              vm.notificationModel = undefined
            }

            vm.edit = true
            $('#myModal').modal('show')
          }
        })
      },
      eventDrop: function (eventModel, delta, revertFunc) {
        EventService.get(eventModel.id).then(function (result) {
          var event = result.results
          var eventCache = _.find(vm.eventSource, { id: eventModel.id })
          event.b.s = eventCache.b.s
          vm.currentEvent = event

          var permissionChannel = _.find(vm.allChannels, { id: event.b.s['id-ch'] })
          if (permissionChannel['id-pu'] !== vm.ownPublisherId) {
            swal('You are not allowed to change this event', '', 'warning')
            revertFunc()
            return
          }

          if (isDate(eventModel.start.format())) {
            var date = parseInt(new Date(eventModel.start.format()).getTime() + '000')
            vm.ts = date
          }

          EventService.update(vm.currentEvent.id, { 'ts-p': vm.ts }).then(function (result) {
            var eventResult = result.results
            for (var i = 0; i < vm.eventSource.length; i++) {
              if (vm.eventSource[i].id === eventResult.id) {
                vm.eventSource.remove(vm.eventSource[i])
                vm.eventSource.push(eventResult)
                break
              }
            }
          })
        })
      },
      viewRender: function (view) {
        var firstDay = parseInt(view.intervalStart._i.toString() + '000')
        var lastDay = parseInt(view.intervalEnd._i.toString() + '000')
        load(firstDay, lastDay)
      },
    })

    vm.isByFilterChannel = false
  }

  vm.filterByChannel = function (item) {
    EventService.listEventByChannels(item.id).then(function (result) {
      for (var i = 0; i < vm.allChannels.length; i++) {
        if (item.id === vm.allChannels[i].id) {
          vm.allChannels[i].isActive = true
        } else {
          vm.allChannels[i].isActive = false
        }
      }
      var events = result.results
      vm.eventSource = events
      vm.events = []
      for (var i = 0; i < events.length; i++) {
        var event = events[i]
        var ts = new Date(
          parseInt(event['ts-p'].toString().substring(0, event['ts-p'].toString().length - 3)),
        )
        vm.events.push({
          id: event.id,
          title: event.t,
          start: ts,
          end: ts,
        })
      }

      vm.isByFilterChannel = true
      vm.dateOldCalendar = $('#calendar').fullCalendar('getDate')
      $('#calendar').fullCalendar('destroy')
      loadCalendar()
    })
  }

  var watch = $scope.$watch('vm.channelId', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    EventService.listSets(newVal).then(function (response) {
      var sets = _.filter(response.results, function (o) {
        return o.st !== 2
      })
      vm.sets = sets
      vm.waitChannel = false
      vm.waitSet = true
    })
  })

  var watch1 = $scope.$watch('vm.setId', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    vm.waitSet = false
    if (vm.isClone) {
      EventService.listPacks(vm.setId).then(function (response) {
        vm.packs = response.results
        vm.waitSet = false
      })
    }
  })

  var watch2 = $scope.$watch('vm.isClone', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal === false) {
      return
    }

    EventService.listPacks(vm.setId).then(function (response) {
      vm.packs = response.results
      vm.waitSet = false
    })
  })

  var watch3 = $scope.$watch('vm.packId', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal === false) {
      return
    }

    EventService.getChannelPostByBundleUrl(vm.channelId, newVal).then(function (result) {
      vm.listChannelPosts = result.results
    })
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
    watch3()
  })

  vm.redirect = function (model, type) {
    localStorage.setItem('channelId', model.b.s['id-ch'])
    localStorage.setItem('setId', model.b.s.id)
    localStorage.setItem('pushId', model.pn.id)
    localStorage.setItem('bundleId', model.b.id)
    var channel = _.find(vm.allChannels, { id: model.b.s['id-ch'] })
    localStorage.setItem('channelName', channel.t)

    switch (type) {
      case 'bundle':
        $state.go('pub.bundles.step1', {
          parentId: model.b.s.id,
          id: model.b.id,
          event: true,
          create: false,
        })
        break
      case 'post':
        $state.go('pub.channels.posts.edit', {
          parentId: model.b.s['id-ch'],
          id: model.p.id,
          event: true,
          create: false,
        })
        break
      case 'notification':
        var ts = ''
        if (model.pn['ts-p'] !== undefined) {
          ts = new Date(
            parseInt(
              model.pn['ts-p'].toString().substring(0, model.pn['ts-p'].toString().length - 3),
            ),
          )
          if (ts <= new Date()) {
            swal("You can't edit push notification has been published")
          } else {
            $state.go('admin.notification_history.edit', {
              id: model.pn.id,
              event: true,
              create: false,
            })
          }
        } else {
          $state.go('admin.notification_history.edit', {
            id: model.pn.id,
            event: true,
            create: false,
          })
        }

        break
      default:
        break
    }
  }
}
